/* eslint-disable import/no-extraneous-dependencies */
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';

import LogRocket from 'logrocket';

import rootReducer from './rootReducer';

const composeEnhancers =
  process.env.NODE_ENV !== 'production'
    ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            trace: true,
            traceLimit: 25,
          })
        : null) || compose
    : compose;

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['society'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk, LogRocket.reduxMiddleware()))
);

const persistor = persistStore(store);

export { store, persistor };
